/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';

export const useIsBacklogRoute = (): boolean => {
	const { name } = useCurrentRoute();

	return useMemo(
		() =>
			name === 'rapidboard-backlog' ||
			name === 'rapidboard-user-backlog' ||
			name === 'rapidboard-backlog-embed',
		[name],
	);
};
